import dayjs from 'dayjs';
import * as yup from 'yup';
import {
  fname,
  lname,
  hphone,
  hstreet1,
  hstreet2,
  hcity,
  hstate,
  hzip,
  email,
} from '../shared/common-validators';

export const validationSchema = yup.object({
  ...fname,
  ...lname,
  ...hphone,
  ...hstreet1,
  ...hstreet2,
  ...hcity,
  ...hstate,
  ...hzip,
  ...email,
  birthdate: yup
    .date()
    .nullable()
    .max(dayjs(), 'Birthdate must be before today')
    .typeError('Invalid Date Format'),
  payfreq: yup
    .string()
    .nullable(),
  payfreq2: yup
    .string()
    .nullable(),

});
